<template>
  <HomePage
    :articles="articles"
    :logos="logos"
  />
</template>

<script setup>
useHead({
  title: 'Proxify Careers – Remote tech jobs with top global companies',
  meta: [
    {
      key: 'og:title',
      property: 'og:title',
      content: 'Proxify Careers – Remote tech jobs with top global companies',
    },
  ],
});

const { $cmsApi } = useNuxtApp();

const { data, error } = await useAsyncData(async () => {
  const articles = await $cmsApi.get('/articles/homepage');

  const logoData = await $cmsApi.get('/homepage/logo-section-logos');
  const logos = {
    firstSectionLogos: logoData?.first_section_logos || [],
    secondSectionLogos: logoData?.second_section_logos || [],
    logos: logoData?.logos || [],
  };

  return {
    articles,
    logos,
  };
});

if (error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: 'Failed to load homepage content',
  });
}

const articles = data.value?.articles || [];
const logos = data.value?.logos || {};
</script>
